import { Badge as ChakraBadge } from "@chakra-ui/react";
import type { ComponentPropsWithRef } from "react";

export type BadgeProps = ComponentPropsWithRef<typeof ChakraBadge>;

export function Badge(props: BadgeProps) {
  return <ChakraBadge {...props} />;
}
